module.exports = __webpack_public_path__ + "assets/f8e65055c95119bd564ca2c80307a0b1.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/prev.mp3
 ** module id = 234
 ** module chunks = 0
 **/